module.exports = __webpack_public_path__ + "img/training-pic4.95f597bd.png";